/* La Torrecilla de TC, a la hoja ARRIBOS de su ARRIBOS Y CORTES.
 *
 * Lautaro Díaz (Satelital), 21/10/2026, en el hilo «SALIDAS DE BUE…»:
 * «CUANDO YO TIRE LAS TORRECILLAS DE TC, QUE SE COMPLETEN EN ARRIBOS DE
 * ARRIBOS Y CORTES». Lo acordado el 20/10: la de TC (TTES. CANTARINI,
 * furgones comunes y los playos de TC) va SÓLO a ARRIBOS Y CORTES, hoja
 * ARRIBOS; la de TCC (bitrenes) va sólo a ONLY BITRENES, hoja ARRIBOS BITREN
 * (`shared/torrecillas.agregarAArribos`). «La de only bitrenes es solo para
 * los bitrenes y arribos y cortes solo para furgones normales».
 *
 * ── SU HOJA ARRIBOS ─────────────────────────────────────────────────────────
 *
 * D/C · ORIG · FUR · TR · CHOFER · CLIENTE · CUSTODIA · LUG / DIA · UBICACION
 * · PERNOCTE dd-mm…, un furgón por renglón:
 *   «19 · RGD · 820 · 742 · LUCERO DANIEL · ELECTRO · ARM · EN CERRI · …».
 * Se escribe lo mismo que él: D/C el día de carga solo («21»), ORIG «RGD»
 * (las Torrecillas son las de Río Grande), FUR el semi, TR el interno o FLT
 * (el fletero, como lo escribe él: la patente va en CORTES), CHOFER, CLIENTE
 * el lugar de carga como en SALIDAS Y CUST y LUG / DIA las «Características
 * del viaje» —como en ARRIBOS BITREN—. CUSTODIA sale del cliente
 * (`custodiaDeCliente`, abajo). UBICACION la completa `ubicacionAlAgregar`, y
 * los pernoctes quedan para él.
 *
 * Se lee por el TÍTULO de cada columna, como el resto: sin D/C y FUR no se
 * escribe (no se sabría qué ya está). Las columnas que no estén se saltean.
 *
 * ── QUÉ VA ──────────────────────────────────────────────────────────────────
 *
 * Sólo el bloque TC, y de él sólo lo que no es bitren: si alguna vez la de TC
 * trae una pareja 15xx o 25xx, ésa es de ONLY BITRENES y acá no se escribe.
 * Sin furgón (FUR vacío) tampoco: no hay con qué ver si ya está.
 *
 * ── LO QUE YA ESTÁ NO SE VUELVE A ESCRIBIR ──────────────────────────────────
 *
 * Un furgón ya está si la hoja lo tiene con el mismo D/C. El D/C de un
 * renglón tapado por una combinada suya vale el de arriba (el ancla). Pero
 * un D/C vacío y sin combinada NO se arrastra del de arriba: él escribe a
 * mano los de hoy sin el día (el 21/10 tenía 806, 822 y 687 así, abajo de
 * los del 20), y arrastrar el 20 hacía que el 806 de hoy se escribiera otra
 * vez. Un furgón con el D/C vacío ya está, sea el día que sea: es preferible
 * no agregar uno que repetirlo, y se ve en el aviso («ya estaban»). El furgón
 * se compara sin lo que anota Tráfico al lado (`claveDeFurgon`: «733 (V)»
 * es 733).
 *
 * ── LO QUE ÉL ESCRIBIÓ NO SE TOCA ───────────────────────────────────────────
 *
 * Cada furgón va en el primer renglón vacío abajo del último con algo (en
 * cualquier columna), donde ninguna combinada suya toca lo que se escribe;
 * los que se saltean se devuelven en `salteadas` para decirlo en pantalla.
 *
 * ── Y TAMBIÉN A CORTES ──────────────────────────────────────────────────────
 *
 * Lautaro, 21/10 10:59: «Tambien lo de tc que se agregue en cortes de arribos
 * y cortes». Su hoja CORTES:
 *
 * D/C · ORIG · FUR · PAT FUR · TRA · CHOFER · CLIENTE · PAT TRA · SATELITAL ·
 * CUSTODIAS · DNI · CELULAR · CORTES · TOMA DE CUSTODIAS · ID
 *   «19 · RGD · 820 · JTI 847 · 742 · LUCERO DANIEL · ELECTRO · AH841UA ·
 *    CAR-TRUCK · ARM · 17.300.241 · 011-1568004050 · · EN CERRI ·».
 *
 * Las mismas reglas que ARRIBOS (por el título, sin repetir FUR + D/C, sin
 * pisar ni escribir bajo sus combinadas), y en el MISMO guardado que ARRIBOS.
 * PAT FUR y PAT TRA son las patentes de la Torrecilla, SATELITAL el del
 * tractor (el del fletero, por su patente), el DNI con los puntos como los
 * escribe él, y TOMA DE CUSTODIAS lo mismo que LUG / DIA en ARRIBOS (así lo
 * tiene él en casi todos sus renglones). CORTES (la columna) e ID quedan para
 * él. Sin D/C y FUR en CORTES, ahí no se escribe y la pantalla lo dice.
 *
 * ── LA CUSTODIA SALE DEL CLIENTE ────────────────────────────────────────────
 *
 * Lautaro, 21/10: «las custodias es lo mismo que arm y assistcargo con sus
 * respectivos clientes […] Van S/CUSTODIA CUANDO ES: ACSUR, BIO ORGANIC, RIO
 * CHICO, GENERAL, VINISA». La relación cliente → aseguradora es la de los
 * correos de enganche del bot (`enganches_destinos.CLIENTES`): ASSISTCARGO
 * para BGH, CARRIER y SOLNIK/SOLNICK; ARM para R.VICTORIA/RADIO VICTORIA y
 * ELECTROFUEGUINA, que en la Torrecilla y en su planilla va «ELECTRO». Se
 * escribe como él: ARM, ASSISTCARGO, S/CUSTODIA. Un cliente que no está en
 * ninguna lista no se adivina: CUSTODIA vacía.
 *
 * Todo acá es puro: lo prueban los tests con datos inventados.
 */

import { mapaCombinadas, normalizarCombinadas, rangoCombinada } from "./planillaCombinadas";
import { pelado, serieDeBitren } from "./torrecillas";
import { claveDeFurgon, diaDe } from "./salidasFurgones";

const txt = (v) => String(v ?? "").replace(/\s+/g, " ").trim();

/* De dónde son las Torrecillas: Río Grande, como lo escribe él en ORIG. */
export const ORIGEN = "RGD";

/* El título pelado → la columna. */
const COLUMNAS = {
  dc: (p) => p === "DC",
  orig: (p) => ["ORIG", "ORIGEN"].includes(p),
  fur: (p) => ["FR", "FUR", "FURGON"].includes(p),
  tr: (p) => ["TR", "TRA", "TRAC", "TRACTOR"].includes(p),
  chofer: (p) => ["CHOFER", "CHOFERES"].includes(p),
  cliente: (p) => p.startsWith("CLIENTE"),
  custodia: (p) => p.startsWith("CUSTODIA"),
  lug: (p) => p === "LUGDIA",
};

/* Los de su hoja CORTES. TOMA DE CUSTODIAS no es CUSTODIAS: empieza con TOMA. */
const COLUMNAS_CORTES = {
  dc: COLUMNAS.dc,
  orig: COLUMNAS.orig,
  fur: COLUMNAS.fur,
  patFur: (p) => ["PATFUR", "PATFURGON", "PATENTEFUR", "PATENTEFURGON", "PATSEMI", "PATENTESEMI"].includes(p),
  tr: COLUMNAS.tr,
  chofer: COLUMNAS.chofer,
  cliente: COLUMNAS.cliente,
  patTr: (p) => ["PATTR", "PATTRA", "PATTRAC", "PATTRACTOR", "PATENTETRACTOR"].includes(p),
  satelital: (p) => p.startsWith("SATELITAL"),
  custodia: COLUMNAS.custodia,
  dni: (p) => p === "DNI",
  cel: (p) => ["CELULAR", "CEL", "TEL", "TELEFONO"].includes(p),
  toma: (p) => p.startsWith("TOMADECUSTODIA"),
};

function encabezadoCon(hoja, columnas) {
  const celdas = hoja?.celdas || [];
  for (let i = 0; i < Math.min(celdas.length, 6); i++) {
    const cols = {};
    (celdas[i] || []).forEach((v, j) => {
      const p = pelado(v);
      for (const [k, es] of Object.entries(columnas)) {
        if (cols[k] === undefined && p && es(p)) cols[k] = j;
      }
    });
    if (cols.dc !== undefined && cols.fur !== undefined) return { fila: i, cols };
  }
  return null;
}

/* `{fila, cols}` del encabezado (en las primeras seis filas) con D/C y FUR,
   o null. */
export const encabezadoArribosFurgones = (hoja) => encabezadoCon(hoja, COLUMNAS);

/* El de su hoja CORTES, con las mismas condiciones. */
export const encabezadoCortesFurgones = (hoja) => encabezadoCon(hoja, COLUMNAS_CORTES);

/* La hoja ARRIBOS de una planilla de furgones (`datos.hojas`), o -1: la que
   se llama ARRIBOS —no CORTES ni SALIDAS, que también tienen D/C y FUR, ni
   ARRIBOS BITREN— y tiene D/C y FUR. */
export function hojaDeArribosFurgones(datos) {
  const hojas = datos?.hojas || [];
  return hojas.findIndex((h) => {
    const n = pelado(h?.nombre);
    return n.includes("ARRIBO") && !n.includes("BITREN") && encabezadoArribosFurgones(h);
  });
}

/* Su hoja CORTES (`datos.hojas`): el índice, o -1 si no hay ninguna que se
   llame CORTES (y no ARRIBOS ni de bitrenes); `sinTitulos` si la hay pero
   sin D/C y FUR: ahí no se escribe y se dice. */
export function hojaDeCortesFurgones(datos) {
  const hojas = datos?.hojas || [];
  const nombre = (h) => {
    const n = pelado(h?.nombre);
    return n.includes("CORTE") && !n.includes("ARRIBO") && !n.includes("BITREN");
  };
  const i = hojas.findIndex((h) => nombre(h) && encabezadoCortesFurgones(h));
  if (i >= 0) return { i, sinTitulos: false };
  return { i: -1, sinTitulos: hojas.some(nombre) };
}

/* ── La custodia de cada cliente ─────────────────────────────────────────── */

/* Como lo escribe él, y los clientes de cada una (como pueden venir escritos).
   ASSISTCARGO y ARM, los de `enganches_destinos.CLIENTES` del bot. */
export const CUSTODIAS = [
  ["ASSISTCARGO", ["BGH", "CARRIER", "SOLNIK", "SOLNICK"]],
  ["ARM", ["R.VICTORIA", "RADIO VICTORIA", "ELECTROFUEGUINA", "ELECTRO", "TECNOMYL"]],
  ["S/CUSTODIA", ["ACSUR", "BIO ORGANIC", "RIO CHICO", "GENERAL", "VINISA"]],
];

/* Sin tildes ni mayúsculas, y todo lo que no es letra o número, un espacio:
   «R.Victoria» → «R VICTORIA». */
const palabras = (v) => String(v ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toUpperCase()
  .replace(/[^A-Z0-9]+/g, " ")
  .trim();

/* TECNOMYL va con ARM y, en LUG / DIA, «SEGUN VALOR» (Lautaro, 28/10, ticket
   546: «En la custodia cuando es tecnomyl le pones ARM y lug/dia segun
   valor»). Si la Torrecilla ya trae algo en Características, va eso. */
export const SEGUN_VALOR = "SEGUN VALOR";
export const lugDeCliente = (cliente, caract) =>
  txt(caract) || (pelado(cliente).startsWith("TECNOMYL") ? SEGUN_VALOR : "");

/* La custodia del cliente (el lugar de carga), o "". Un cliente es de la
   lista si EMPIEZA con uno de sus nombres, palabra entera —«SOLNIK WILSON»,
   «ELECTRO LOG CENTRAL», «R.VICTORIA LOG CENTRAL»—, o si es el mismo sin
   espacios ni puntos («BIOORGANIC», «RVICTORIA»). Palabra entera para no
   confundir: «ELECTRONICA SUR» no es ELECTRO, ni «GENERALI» GENERAL. */
export function custodiaDeCliente(cliente) {
  const c = palabras(cliente);
  if (!c) return "";
  for (const [custodia, clientes] of CUSTODIAS) {
    for (const n of clientes) {
      const a = palabras(n);
      if (c === a || c.startsWith(`${a} `) || pelado(c) === pelado(a)) return custodia;
    }
  }
  return "";
}

/* La que se propone: la que se llama ARRIBOS Y CORTES; si no, una que diga
   ARRIBOS o CORTES; si no, la primera que no es de bitrenes. Nunca una de
   bitrenes: la de TC no va a ONLY BITRENES. */
export function planillaDeArribosPropuesta(planillas) {
  const lista = (planillas || []).filter((p) => !pelado(p.nombre).includes("BITREN"));
  const n = (p) => pelado(p.nombre);
  const p = lista.find((x) => n(x).includes("ARRIBOS") && n(x).includes("CORTES"))
    || lista.find((x) => /ARRIBOS|CORTES/.test(n(x)))
    || lista[0];
  return p?.id || "";
}

/* Las filas de TC que van a ARRIBOS: las del bloque TC que no son parte de
   un bitren ni de la serie de bitren, y que tienen furgón. */
export function comunesDeTC(bloques, furgones = {}) {
  const tc = (bloques || []).find((b) => b.empresa === "TC");
  if (!tc) return [];
  return tc.filas.filter((f) => !f.parte && claveDeFurgon(f.semi) && !serieDeBitren(f.semi, furgones));
}

const diaDeFecha = (iso) => {
  const m = /^\d{4}-\d{2}-(\d{2})$/.exec(String(iso ?? ""));
  return m ? String(Number(m[1])) : "";
};

/* Los furgones que la hoja ya tiene: `Map` de clave de furgón → Set de D/C
   («» = sin día: vale cualquiera). */
function yaEnLaHoja(hoja, enc) {
  const { fila, cols } = enc;
  const mapa = mapaCombinadas(hoja.combinadas);
  const celdas = hoja.celdas || [];
  const hay = new Map();
  celdas.forEach((r, i) => {
    if (i <= fila || !r) return;
    const fr = claveDeFurgon(r[cols.fur]);
    if (!fr) return;
    let d = diaDe(r[cols.dc]);
    const rg = mapa.get(`${i},${cols.dc}`);
    if (!d && rg && rg.r0 !== i) d = diaDe(celdas[rg.r0]?.[rg.c0]);
    if (!hay.has(fr)) hay.set(fr, new Set());
    hay.get(fr).add(d);
  });
  return hay;
}

const estaEn = (hay, dc, furgon) => {
  const dias = hay.get(claveDeFurgon(furgon));
  return Boolean(dias && (dias.has(dc) || dias.has("")));
};

/* Cuáles de las filas ya están en la hoja: `Set` de `semi`. */
export function cualesYaEstanEnArribos(hoja, filas, fecha) {
  const enc = encabezadoArribosFurgones(hoja);
  if (!enc) return new Set();
  const hay = yaEnLaHoja(hoja, enc);
  const dc = diaDeFecha(fecha);
  return new Set((filas || []).filter((f) => estaEn(hay, dc, f.semi)).map((f) => f.semi));
}

/* Suma a la hoja las filas de TC que no tiene, una por renglón, en las
   columnas de `enc`; `valores(f, dc)` dice qué va en cada una. */
function sumarFurgones(hoja, filas, fecha, enc, valoresDe) {
  const vacio = { hoja, agregados: 0, yaEstaban: 0, salteadas: [], nuevas: [] };
  const dc = diaDeFecha(fecha);
  if (!enc || !dc) return vacio;
  const { fila, cols } = enc;
  const suyas = normalizarCombinadas(hoja.combinadas || []).map(rangoCombinada).filter(Boolean);
  // Una combinada suya saltea el renglón sólo si toca una celda que se
  // escribe en él (`huella`): una CUSTODIA que queda vacía no estorba.
  const sirve = (r, huella) => !suyas.some(
    (m) => m.r0 <= r && r <= m.r1 && huella.some((c) => m.c0 <= c && c <= m.c1),
  );
  const celdas = (hoja.celdas || []).map((r) => [...(r || [])]);
  const ancho = Math.max(hoja.cols || 0, ...celdas.map((r) => r.length));
  const hay = yaEnLaHoja(hoja, enc);
  let ultima = fila;
  celdas.forEach((r, i) => {
    if (i > fila && r.some((v) => txt(v))) ultima = i;
  });
  const salteadas = [];
  const nuevas = [];
  let agregados = 0;
  let yaEstaban = 0;
  let en = ultima + 1;
  const vacia = () => Array.from({ length: ancho }, () => "");
  for (const f of filas || []) {
    const fr = claveDeFurgon(f.semi);
    if (!fr) continue;
    if (estaEn(hay, dc, f.semi)) {
      yaEstaban += 1;
      continue;
    }
    const escribir = Object.entries(valoresDe(f, dc))
      .filter(([campo, v]) => cols[campo] !== undefined && v)
      .map(([campo, v]) => [cols[campo], v]);
    const huella = escribir.map(([c]) => c);
    while (!sirve(en, huella)) {
      salteadas.push(en + 1);
      en += 1;
    }
    const r = celdas[en] ? [...celdas[en]] : vacia();
    while (r.length < ancho) r.push("");
    // El renglón está vacío entero: va después del último con algo.
    for (const [c, v] of escribir) r[c] = v;
    celdas[en] = r;
    if (!hay.has(fr)) hay.set(fr, new Set());
    hay.get(fr).add(dc);
    nuevas.push(en);
    en += 1;
    agregados += 1;
  }
  if (!agregados) return { ...vacio, yaEstaban };
  for (let i = 0; i < celdas.length; i++) if (!celdas[i]) celdas[i] = vacia();
  return {
    hoja: { ...hoja, celdas, filas: Math.max(hoja.filas || 0, celdas.length), cols: ancho },
    agregados,
    yaEstaban,
    salteadas,
    nuevas,
  };
}

/* Suma a la hoja ARRIBOS las filas de TC que no tiene, una por renglón.
   Devuelve `{hoja, agregados, yaEstaban, salteadas, nuevas}`; la hoja que
   entra no se toca. `nuevas` son los renglones escritos (índices desde 0):
   ahí después va la UBICACIÓN (`services/ubicacionAlAgregar`). */
export function agregarAArribosFurgones(hoja, filas, fecha) {
  return sumarFurgones(hoja, filas, fecha, encabezadoArribosFurgones(hoja), (f, dc) => ({
    dc, orig: ORIGEN, fur: txt(f.semi), tr: txt(f.tractor), chofer: txt(f.chofer),
    cliente: txt(f.lugar), custodia: custodiaDeCliente(f.lugar), lug: lugDeCliente(f.lugar, f.caract),
  }));
}

/* El DNI con los puntos de los miles, como lo escribe él: «17.300.241». */
export const dniConPuntos = (v) => {
  const t = txt(v);
  return /^\d{7,8}$/.test(t) ? t.replace(/\B(?=(\d{3})+$)/g, ".") : t;
};

/* Lo mismo, a su hoja CORTES. */
export function agregarACortesFurgones(hoja, filas, fecha) {
  return sumarFurgones(hoja, filas, fecha, encabezadoCortesFurgones(hoja), (f, dc) => ({
    dc, orig: ORIGEN, fur: txt(f.semi), patFur: txt(f.patSemi), tr: txt(f.tractor),
    chofer: txt(f.chofer), cliente: txt(f.lugar), patTr: txt(f.patTractor),
    satelital: txt(f.satelital), custodia: custodiaDeCliente(f.lugar), dni: dniConPuntos(f.dni),
    cel: txt(f.tel), toma: lugDeCliente(f.lugar, f.caract),
  }));
}
